<bit-section [formGroup]="sendFileDetailsForm">
  @if (sendFormService.sendFormConfig.mode === "edit") {
    <div
      [class]="
        !editing()
          ? 'tw-border-secondary-300/50 tw-border-b tw-border-0 tw-border-solid tw-pb-[2px]'
          : ''
      "
    >
      <div bitTypography="body2" class="tw-text-muted">{{ "file" | i18n }}</div>
      <div class="tw-text-wrap tw-break-all" data-testid="file-name">
        {{ sendFormService.originalSendView()?.file.fileName }}
      </div>
      <div data-testid="file-size" class="tw-text-muted">
        {{ sendFormService.originalSendView()?.file.sizeName }}
      </div>
    </div>
  } @else {
    <bit-form-field>
      <bit-label for="file">{{ "fileToShare" | i18n }}</bit-label>
      <div class="tw-flex tw-mt-2 tw-mb-1">
        <button bitButton type="button" buttonType="secondary" (click)="fileSelector.click()">
          {{ "chooseFile" | i18n }}
        </button>
        <span
          class="tw-flex tw-items-center tw-pl-3"
          [class.tw-text-main]="fileName()"
          [class.tw-text-muted]="!fileName()"
        >
          {{ fileName() || ("noFileChosen" | i18n) }}</span
        >
      </div>
      <input
        bitInput
        #fileSelector
        type="file"
        formControlName="file"
        hidden
        (change)="onFileSelected($event)"
      />
      <bit-hint>
        {{ "maxFileSize" | i18n }}
      </bit-hint>
    </bit-form-field>
  }
</bit-section>
